import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { Panel } from '../../components/primitives/Panel';
import type { TargetRow } from '../outreachTypes';
import { TargetRowView } from './TargetRowView';
import { findMessages as messages } from './findMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import styles from './Find.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TargetTableProps {
  rows: TargetRow[];
  onOpen: (targetUuid: string) => void;
}

/** The target table of Find (design outreach c1). */
const TargetTableComponent: React.FC<TargetTableProps> = ({ rows, onOpen }) => {
  const intl = useIntl();
  const items = useMemo(
    () => rows.map((row) => <TargetRowView key={row.targetUuid} row={row} onOpen={onOpen} />),
    [onOpen, rows]
  );
  return (
    <Panel as="section">
      <div className={shared.table} data-testid="target-table">
        <div className={clsx(shared.tableRow, shared.tableHead, styles.targetRow)}>
          <span />
          <span>{intl.formatMessage(messages.colTarget)}</span>
          <span className={clsx(shared.cellNum, styles.hideNarrow)}>{intl.formatMessage(messages.colFollowers)}</span>
          <span className={styles.hideNarrow}>{intl.formatMessage(messages.colWhy)}</span>
          <span className={styles.hideNarrow}>{intl.formatMessage(messages.colContact)}</span>
          <span className={shared.cellNum}>{intl.formatMessage(messages.colFit)}</span>
        </div>
        {items}
      </div>
    </Panel>
  );
};

export const TargetTable = TypedMemo(TargetTableComponent);
